<template>
    <section class="base-header-sec base-header-laen  laen">
        <div class="base-header__top-line laen"></div>
        <div class="container-fluid">

            <div class=" container-lg  base-header__container ">
                <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                    <h2 class="base-header__title mob d-block d-lg-none">
                        Судска пракса
                    </h2>
                    <ul class="nav ">
                        <li class="nav-item ">
                            <router-link class="nav-link  " to="/supa-latest">Најновије</router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link base-sub-page-link" to="/supa-standardSearch" id="tab-svi-brojevi">
                                Стандардна претрага
                            </router-link>
                        </li>

                        <li class="nav-item ">
                            <router-link class="nav-link " to="/supa-advancedSearch-ccSearch">
                                Напредна претрага
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " to="/supa-registries">
                                Регистри
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/supa-static', query: { page: 'help' ,code:'SP'}}">
                                Помоћ
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/supa-static', query: { page: 'contact' ,code:'SP'}}">
                                Контакт
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/supa-static', query: { page: 'impresum' ,code:'SP'}}">
                                Импресум
                            </router-link>
                        </li>

                    </ul>
                    <h1 class="base-header__title d-none d-lg-block">
                        Судска пракса
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "SupaBaseHeaderSec"
    }
</script>

<style scoped>

</style>
